import { useAuth } from '@/contexts/AuthContext';

export const useOrganizations = () => {
  const { 
    organizations, 
    currentOrganization, 
    switchOrganization, 
    loading: isLoading 
  } = useAuth();

  return {
    organizations,
    currentOrganization,
    switchOrganization,
    isLoading
  };
};
